// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Kv-I","questions":"styles_questions__1dr_i","footer":"styles_footer__1-Th5"};